
<template>
  <div>
    <v-row v-if="newItem.kind == 'custom_field'" class="ml-n5 mt-5">
      <v-col cols="11" md="10" class="py-0">
        <span>Com os campos personalizados é possivel selecionar uma lista externa para utilizar durante a execução de um formulário</span>
        <v-row align="center" justify="start" class="ml-6">
          <v-select
            :items="all_custom_fields"
            v-model="newItem.custom_field_id"
            label="Conecte a uma lista"
            item-text="name"
            item-value="id"
            prepend-icon="mdi-database-import mdi-flip-h"
            color="secondary"
            item-color="secondary"
          >
            <template v-slot:append-item>
              <v-divider class="mt-2"></v-divider>
              <v-row justify="center" class="pt-3">
                <v-btn color="secondary" :to="{name: 'ListCustomField'}" rounded><v-icon left>mdi-plus</v-icon>Nova Lista</v-btn>
              </v-row>
            </template>
          </v-select>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index'

export default {
  data() {
    return {
      newItem: this.$attrs.newItem,
      all_custom_fields: [],
    }
  },
  methods: {
    getCustomFields(){
      Api.CustomField.index({with_cv: true}).then(r=>r.data).then(cf=>{
        cf = cf.data? cf.data.map(c=> c.attributes) : cf
        this.all_custom_fields = [...cf]
      })
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  created () {
    this.getCustomFields();
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
  },
}
</script>

<style scoped>

</style>